<template>
  <div class="my-quotes">
    <h2 class="my-quotes__heading">
      Quotes
    </h2>

    <div class="my-quotes__container">
      <div v-if="loading"
           class="my-quotes__loading-container">
        <div class="my-quotes__loading-content">
          <h6>Loading quotes</h6>
          <font-awesome-icon icon="spinner"
                             class="icon"
                             size="lg"
                             spin></font-awesome-icon>
        </div>
      </div>

      <div class="my-quotes__filter">
        <span class="my-quotes__filter-header">
          Filter:
        </span>

        <b-form-checkbox v-model="showConverted"
                         class="my-quotes__filter-item">
          Show converted quotes
        </b-form-checkbox>

        <button
          class="btn btn-sm refresh-btn"
          :disabled="loading"
          aria-label="My quotes"
          @click="fetchData">
          <font-awesome-icon icon="sync-alt"
                             class="align-right icon">
          </font-awesome-icon>
          Refresh
        </button>
      </div>

      <template v-if="quotes && quotes.length > 0">
        <quotes-table
          class="my-quotes__table"
          :quotes="quotes"
          @show-convert-modal="showConvertModal">
        </quotes-table>

        <div class="my-quotes__cards">
          <quote-item
            v-for="(item, index) in quotes"
            :key="index"
            :quote="item"
            @show-convert-modal="showConvertModal">
          </quote-item>
        </div>
      </template>
      <template v-else>
        <div class="my-quotes__empty">
          <p>No quotes found.</p>
        </div>
      </template>

      <CustomModal :show="showModal"
                   heading="Convert to basket"
                   @close="hideConvertModal">
        <template #default>
          <p>
            Any products that are currently in your basket will be lost. Do you want to proceed?
          </p>
        </template>

        <template #footer>
          <button
            class="btn btn-accent-1 btn-convert"
            aria-label="convert order to basket"
            @click="convertToBasket">
            <template v-if="processingConversion">
              <span class="visually-hidden">
                Loading...
              </span>
              <font-awesome-icon icon="spinner"
                                 class="icon"
                                 size="lg"
                                 spin></font-awesome-icon>
            </template>
            <template v-else>
              Convert to basket
            </template>
          </button>
        </template>
      </CustomModal>
    </div>
  </div>
</template>

<script>
import QuotesTable from "~/Components/Quotes/QuotesTable.vue";
import QuoteItem from "~/Components/Quotes/QuoteItem.vue";
import CustomModal from "~/Components/CustomModal.vue";
import { loadQuotes, convertToBasket } from "~/Scripts/resources/quotesResource";

export default {
  name: "MyQuotes",
  components: {
    QuotesTable,
    QuoteItem,
    CustomModal
  },
  data () {
    return {
      quotes: [],
      loading: false,
      showModal: false,
      showConverted: false,
      selectedQuoteId: null,
      processingConversion: false
    };
  },
  watch: {
    showConverted () {
      this.fetchData();
    }
  },
  mounted () {
    this.fetchData();
  },
  methods: {
    fetchData () {
      this.loading = true;
      loadQuotes( this.showConverted )
        .then( result => {
          if ( result && result.data ) {
            this.quotes = result.data;
          }
        } )
        .catch( error => {
          console.error( "error occured when loading quotes", error );
          throw error;
        } )
        .finally( () => {
          this.loading = false;
        } );
    },
    showConvertModal ( quoteId ) {
      this.showModal = true;
      this.selectedQuoteId = quoteId;
    },
    hideConvertModal () {
      this.showModal = false;
      this.selectedQuoteId = null;
    },
    convertToBasket () {
      if ( !this.processingConversion ) {
        this.processingConversion = true;
        convertToBasket( this.selectedQuoteId )
          .then( response => {
            if ( response.data ) {
              window.location = "/basket";
            } else {
              throw new Error( "Server response indicates a failure" );
            }
          } )
          .finally( () => {
            this.processingConversion = false;
          } );
      }
    }
  }
};
</script>

<style lang="less" scoped>
.my-quotes {
  position: relative;

  &__container {
    max-height: 100%;
    overflow-x: auto;
    position: relative;
  }

  &__heading {
    letter-spacing: normal;
    font-weight: bold;
    font-size: 16pt;
    margin-top: 0;
    margin-bottom: 30px;
  }

  &__filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 2px solid #b2d6d9;
    background-color: #fff;
    padding: 14px 10px;
    margin-bottom: 20px;

    &-header {
      font-weight: 600;
      color: #0c499c;
      margin-right: 15px;
    }
  }

  &__filter-item {
    flex-grow: 1;
  }

  &__loading-container {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    position: absolute;
    z-index: 100;
    pointer-events: none;
    background-color: rgba(255, 255, 255, 0.7);
  }

  &__loading-content {
    display: flex;
    align-items: center;
    margin-top: 20px;

    h6 {
      margin-bottom: 0;
    }

    .icon {
      margin: 10px;
    }
  }

  &__table {
    @media screen and (max-width: 991px) {
      display: none;
    }
  }

  &__cards {
    @media screen and (min-width: 992px) {
      display: none;
    }
  }

  &__empty {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }

  .refresh-btn {
    align-self: flex-end;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    color: black;

    &:hover {
      color: gray;
    }

    .icon {
      margin-right: 5px;
    }
  }

  .btn-convert {
    min-width: 180px;
  }
}
</style>
